import request from '@/utils/request'
const apiPath = '/sys/sysGoods'
import { downloadBlob } from '@/utils/download'
const sysGoodsApi = {
  /**
   * 新增【系统商品】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【系统商品】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【系统商品】
   */
  fetchList(query) {
    return request.get(apiPath + '/list2', { params: query })
  },
  inventoryShortage(query) {
    return request.get(apiPath + '/inventoryShortage', { params: query })
  },
  exportExcel2(query) {
    return request.get(apiPath + '/exportExcel2', { params: query })
  },
  /**
   * 查询【系统商品】选项列表
   */
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  productOptions(query) {
    return request.get(`${apiPath}/tee/listPageForMini`, { params: query })
  },
  /**
   * 查看【系统商品】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  fetchByCode(id) {
    return request.get(`${apiPath}/tee/getGoodsByCode/${id}`)
  },
  /**
   * 删除单个【系统商品】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  batchRecommend(data) {
    return request.post(apiPath + '/batchRecommend', data, { isFormData: 1 })
  },
  batchState(data) {
    return request.post(apiPath + '/batchState', data, { isFormData: 1 })
  },
  saveProdSpec(data) {
    return request.post(apiPath + '/addSpec', data, { isFormData: 1 })
  },
  getGoodRecomList(data) {
    return request.post(apiPath + '/getConfigList', data)
  },
  exportExcel(query) {
    return request.get(`${apiPath}/export`, { responseType: 'blob', params: query })
      .then(res => downloadBlob(res, '商品列表.xlsx'))
  },
  synchronizeInventory(query) {
    return request.get(apiPath + '/synchronizeInventory', { params: query })
  },
  /**
   * 获取用友商品数据
   */
  getGoodsByYongYouCode(data) {
    return request.post(`${apiPath}/getGoodsInfo`, data, { isFormData: 1 })
  },
  /**
   * 获取用友商品库存数据
   */
  getGoodsQuantityByYongYouCode(data) {
    return request.post(`${apiPath}/getGoodsInventory`, data, { isFormData: 1 })
  },
  synchronizeSysGoodsInfo(query) {
    return request.get(`${apiPath}/synchronizeSysGoodsInfo`, { params: query })
  },
  getSysGoodsQRCode(data) {
    return request.post(`${apiPath}/getSysGoodsQRCode`, data, { isFormData: 1 })
  },
}
export default sysGoodsApi
